import {
  Checkbox,
  Loader,
  Message,
  Modal,
  SelectPicker,
  Uploader,
  useToaster,
} from "rsuite";
import { getPurchasingConditionReportDataForExcel } from "../../react-query/hooks/HVendorQuoteAssessment";
import JSZip from "jszip";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useState } from "react";

interface IExecuteAssesmentModalProps {
  isOpen: boolean;
  handleCancel: () => void;
  handleExecute: () => void;
}

const ExecuteAssesmentModal = ({
  isOpen,
  handleCancel,
  handleExecute,
}: IExecuteAssesmentModalProps) => {
  const [isChecked, setIschecked] = useState<boolean>(false);
  return (
    <div className="flex justify-center items-center">
      <Modal
        className="w-[30vw] execute-assessment-modal"
        open={isOpen}
        onClose={handleCancel}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title className="font-bold text-[1.05vw] text-red-800 pb-2">
            {"Warning !!!"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex flex-col justify-between items-center gap-1.5 pt-[0vh] pb-[2vh]">
            <div className="flex justify-start items-center w-full px-[1vh] pb-[2.5vh]">
              <span className="text-[0.9vw] font-semibold text-red-800">
                The assessment can only be executed once for a commodity. Ensure
                that all supplier quotes are uploaded before executing
              </span>
            </div>

            <div className="flex flex-col w-full">
              <div>
                <Checkbox
                  checked={isChecked}
                  onChange={() => setIschecked(!isChecked)}
                >
                  <span className={`text-[0.9vw] font-semibold`}>
                    Go ahead with Executing Assessment
                  </span>
                </Checkbox>
              </div>
              <div className="flex justify-center items-center gap-4 w-full px-[0.5vw] py-[0.5vh]">
                <button
                  onClick={handleExecute}
                  className={`w-[35%] text-[1vw] font-semibold bg-deloitteGreen rounded-md text-white px-[0.8vw] py-[0.8vh] ${!isChecked
                      ? "cursor-not-allowed opacity-50"
                      : "cursor-pointer"
                    }`}
                  disabled={!isChecked}
                >
                  Execute
                </button>
                <button
                  onClick={handleCancel}
                  className={`w-[35%] text-[1vw] font-semibold bg-deloitteGreen rounded-md text-white px-[0.8vw] py-[0.8vh]`}
                // disabled={!allowAssessment}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ExecuteAssesmentModal;
